import React, { useState, useEffect } from 'react';
import { getTenantFromBackend, getAvailableTenants, getTenantUrl } from '../services/api';
import './Login.css';

/**
 * Shown when the app is opened without a tenant subdomain (or ?tenant= on localhost).
 * Blocks access to all other pages until the user uses a tenant URL.
 */
function NoTenantPage() {
  const [currentTenant, setCurrentTenant] = useState(null);
  const [availableTenants, setAvailableTenants] = useState([]);
  useEffect(() => {
    getTenantFromBackend().then(setCurrentTenant);
    getAvailableTenants().then(setAvailableTenants);
  }, []);
  const isLocalhost =
    typeof window !== 'undefined' &&
    ['localhost', '127.0.0.1', '::1'].includes((window.location.hostname || '').toLowerCase());

  return (
    <>
    {/* <div className="auth-container" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '1.5rem' }}>
      <div className="auth-card" style={{ maxWidth: '480px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--text-primary, #1a1a1a)' }}>
          Tenant required
        </h1>
        <p style={{ marginBottom: '1rem', fontSize: '0.875rem', color: 'var(--text-muted, #888)' }}>
          Current tenant <small>(from backend):</small> <strong style={{ color: 'var(--text-secondary, #555)' }}>{currentTenant === null ? '...' : (currentTenant || '(none)')}</strong>
        </p>
        <p style={{ marginBottom: '1rem', color: 'var(--text-secondary, #555)', lineHeight: 1.6 }}>
          This application must be opened with a tenant subdomain. You cannot access any page without it.
        </p>
        <p style={{ marginBottom: '1.5rem', fontSize: '0.95rem', color: 'var(--text-secondary, #555)', lineHeight: 1.6 }}>
          {isLocalhost ? (
            <>
              <strong>On localhost, use one of:</strong>
              <br />
              • <code style={{ background: '#eee', padding: '0.2em 0.4em', borderRadius: 4 }}>https://your-tenant.localhost:3000</code>
              <br />
              • <code style={{ background: '#eee', padding: '0.2em 0.4em', borderRadius: 4 }}>http://localhost:3000?tenant=your-tenant</code>
            </>
          ) : (
            <>
              <strong>Use your tenant URL, for example:</strong>
              <br />
              <code style={{ background: '#eee', padding: '0.2em 0.4em', borderRadius: 4 }}>https://your-tenant.{typeof window !== 'undefined' ? window.location.hostname : 'yourdomain.com'}</code>
            </>
          )}
        </p>
        {availableTenants.length > 0 && (
          <div style={{ marginTop: '1.5rem', textAlign: 'left' }}>
            <strong style={{ fontSize: '0.875rem', color: 'var(--text-secondary, #555)' }}>Available tenants:</strong>
            <ul style={{ marginTop: '0.5rem', paddingLeft: '1.25rem', fontSize: '0.875rem', color: 'var(--text-secondary, #555)' }}>
              {availableTenants.map((t) => (
                <li key={t.subdomain}>
                  <a
                    href={getTenantUrl(t.subdomain)}
                    style={{ color: 'var(--primary, #2563eb)', textDecoration: 'none' }}
                  >
                    {t.name || t.subdomain} ({t.subdomain})
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
        <p style={{ marginTop: '1rem', fontSize: '0.875rem', color: 'var(--text-muted, #888)' }}>
          If you do not have a tenant URL, contact your administrator.
        </p>
      </div>
    </div> */}
    </>
  );
}

export default NoTenantPage;
